const FixedNumber = (number) => {
	return Number.parseFloat(Number.parseFloat(number).toFixed(1));
};

const IntersectionCoordinates = ({ x0, y0 }, { x1, y1 }, { x, y }) => {
	// (y - y0) / (y1 - y0) = (x - x0) / (x1 - x0)
	if (typeof x !== 'undefined') {
		y = ((x - x0) / (x1 - x0)) * (y1 - y0) + Number(y0);
	} else {
		x = ((y - y0) / (y1 - y0)) * (x1 - x0) + Number(x0);
	}

	return { x, y };
};

export { FixedNumber, IntersectionCoordinates };